import _KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import _KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import React from 'react';
import { Button, MobileStepper } from '@mui/material';
import SwipeableViews from 'react-swipeable-views';
import { virtualize } from 'react-swipeable-views-utils';
import { StepperPlaceholder } from 'app/components/styles/swipeableViews/StepperPlaceholder';
import useSwipeableViewsActiveStep from 'app/components/swipeableViews/useSwipeableViewsActiveStep';
const VirtualizeSwipeableViews = virtualize(SwipeableViews);
const SwipeableViewsStepper = _ref => {
  let {
    stepCount,
    viewRender,
    className,
    hideStepperWithoutPages,
    callback
  } = _ref;
  const {
    activeStep,
    maxSteps,
    handleNext,
    handleBack,
    handleIndexChange
  } = useSwipeableViewsActiveStep(stepCount, callback);
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    "data-sentry-component": "SwipeableViewsStepper",
    "data-sentry-source-file": "SwipeableViewsStepper.tsx"
  }, /*#__PURE__*/React.createElement(VirtualizeSwipeableViews, {
    index: activeStep,
    onChangeIndex: handleIndexChange,
    overscanSlideBefore: activeStep > 0 ? 1 : 0,
    overscanSlideAfter: activeStep < maxSteps ? 1 : 0,
    slideCount: stepCount,
    slideRenderer: viewRender,
    "data-sentry-element": "VirtualizeSwipeableViews",
    "data-sentry-source-file": "SwipeableViewsStepper.tsx"
  }), stepCount > 1 ? /*#__PURE__*/React.createElement(MobileStepper, {
    steps: stepCount,
    position: "static",
    activeStep: activeStep,
    nextButton: /*#__PURE__*/React.createElement(Button, {
      size: "small",
      onClick: handleNext,
      disabled: activeStep >= maxSteps
    }, /*#__PURE__*/React.createElement(_KeyboardArrowRight, null)),
    backButton: /*#__PURE__*/React.createElement(Button, {
      size: "small",
      onClick: handleBack,
      disabled: activeStep <= 0
    }, /*#__PURE__*/React.createElement(_KeyboardArrowLeft, null))
  }) : hideStepperWithoutPages ? null : /*#__PURE__*/React.createElement(StepperPlaceholder, null));
};
export default SwipeableViewsStepper;